import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/**
 * Install-matrix table: rows are install paths, columns are
 * capabilities. Driven by the copy deck so marketing and docs stay in
 * sync.
 */
import { mono, sans, serif } from '../fonts.js';
import { Tooltip } from './Tooltip.js';
import { CheckMark, DashMark } from './icons.js';
export function InstallMatrix({ theme, copy }) {
    const m = copy.installMatrix;
    return (_jsxs("section", { style: { display: 'grid', gap: 14 }, children: [_jsx("span", { style: {
                    ...mono,
                    fontSize: 11,
                    letterSpacing: 2,
                    textTransform: 'uppercase',
                    color: theme.muted,
                }, children: m.kicker }), _jsx("h2", { style: {
                    ...serif,
                    fontWeight: 400,
                    fontSize: 30,
                    lineHeight: 1.1,
                    margin: 0,
                    color: theme.text,
                    textWrap: 'balance',
                }, children: m.heading }), _jsx("p", { style: { ...sans, fontSize: 14, color: theme.muted, margin: 0, maxWidth: '70ch' }, children: m.note }), _jsx("div", { style: { overflowX: 'auto', border: `1px solid ${theme.border}`, borderRadius: 3, background: theme.surface }, children: _jsxs("table", { style: {
                        width: '100%',
                        minWidth: 640,
                        borderCollapse: 'collapse',
                        ...sans,
                        fontSize: 14,
                    }, children: [_jsx("thead", { children: _jsxs("tr", { children: [_jsx("th", { scope: "col", style: {
                                            ...mono,
                                            fontSize: 11,
                                            letterSpacing: 1.6,
                                            textTransform: 'uppercase',
                                            color: theme.muted,
                                            fontWeight: 400,
                                            borderBottom: `1px solid ${theme.border}`,
                                            textAlign: 'left',
                                            padding: '10px 10px',
                                        }, children: "Install" }), m.columns.map((c) => (_jsx("th", { scope: "col", style: {
                                            ...mono,
                                            fontSize: 11,
                                            letterSpacing: 1.6,
                                            textTransform: 'uppercase',
                                            color: theme.muted,
                                            fontWeight: 400,
                                            borderBottom: `1px solid ${theme.border}`,
                                            textAlign: 'left',
                                            padding: '10px 10px',
                                        }, children: c }, c)))] }) }), _jsx("tbody", { children: m.rows.map((r) => (_jsxs("tr", { children: [_jsx("th", { scope: "row", style: {
                                            color: theme.text,
                                            fontWeight: 500,
                                            borderBottom: `1px solid ${theme.borderSoft}`,
                                            textAlign: 'left',
                                            padding: '10px 10px',
                                        }, children: _jsx(Tooltip, { tip: r.tip, theme: theme, children: r.name }) }), r.cells.map((cell, i) => (_jsxs("td", { style: {
                                            borderBottom: `1px solid ${theme.borderSoft}`,
                                            padding: '10px 10px',
                                            verticalAlign: 'top',
                                        }, children: [_jsx("span", { style: { color: cell.ok ? theme.limeFg : theme.dim, display: 'block' }, children: cell.ok ? _jsx(CheckMark, {}) : _jsx(DashMark, {}) }), cell.note !== undefined ? (_jsx("small", { style: { display: 'block', color: theme.muted, fontSize: 12, marginTop: 2 }, children: cell.note })) : null] }, i)))] }, r.name))) })] }) })] }));
}
//# sourceMappingURL=InstallMatrix.js.map